import styled from "styled-components";
import { DefaultButton, Spinner } from "@fluentui/react";

export const PageRoot = styled.div`
    padding: 0rem 1.5rem 2rem;
`;

export const PageTitle = styled.h2`
    cursor: default;
`;

export const Description = styled.p`
    font-size: 24px;
    line-height: 32px;
    cursor: default;
`;

export const OwnerHint = styled.p`
    cursor: default;
    margin-top: 15px;
    font-size: 15px;
    background: #fff4ce;
    width: fit-content;
    border-radius: 12px;
    padding: 5px 10px;
`;

export const SpinnerContainer = styled.div`
    margin-top: 2rem;
`;

export const GoToIdentitiesWrap = styled.div`
    padding-left: 30px;
    padding-top: 15px;
`;

export const ErrorText = styled.p`
    padding-left: 30px;
    padding-top: 30px;
    font-size: 15px;
    cursor: default;
    color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
    font-weight: bold;
`;

export const ActionsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 16px;
    flex-wrap: wrap;
`;

const tinyButtonBase = `
    display: inline-block;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    font-family: Barlow;
    font-weight: 600 !important;
    padding: 8px 32px !important;
    max-width: 100%;
    box-sizing: content-box;
    border-width: 2px !important;
    border-style: solid;
    margin: 0;

    span
    {
        font-weight: 600 !important;
        line-height: unset;
    }
`;

export const PrimaryButton = styled(DefaultButton)`
    ${tinyButtonBase}
    background: #CC214F !important;
    border-color: #CC214F !important;
    color: #FFFFFF !important;
    border-radius: 24px;

    &:focus
    {
        background: #CC214F !important;
        border-color: #CC214F !important;
    }

    &:hover
    {
        background: #D64D73 !important;
        border-color: #D64D73 !important;
        box-shadow: 0px 2px 64px rgba(8, 84, 117, 0.12), 0px 1px 20px rgba(8, 84, 117, 0.12);
        color: #FFFFFF !important;
    }

    &:active
    {
        background: #B31540 !important;
        border-color: #B31540 !important;
        color: #FFFFFF !important;
    }

    &.is-disabled,
    &.is-disabled:hover,
    &:disabled
    {
        background: #DFE3E3 !important;
        border-color: #DFE3E3 !important;
        color: #93AEB9 !important;
        box-shadow: none;
    }
`;

export const SecondaryButton = styled(DefaultButton)`
    ${tinyButtonBase}
    background: #FFFFFF !important;
    border-color: #CC214F !important;
    color: #CC214F !important;
    border-radius: 24px;

    &:hover
    {
        background: #FAE9ED !important;
        color: #CC214F !important;
        border-color: #F1BAC9 !important;
        box-shadow: 0px 2px 64px rgba(8, 84, 117, 0.12), 0px 1px 20px rgba(8, 84, 117, 0.12);
    }

    &:active
    {
        background: #FFFFFF !important;
        border-color: #B31540 !important;
    }

    &.is-disabled,
    &.is-disabled:hover,
    &:disabled
    {
        background: #FFFFFF !important;
        border-color: #DFE3E3 !important;
        color: #93AEB9 !important;
        box-shadow: none;
    }
`;

export const ButtonSpinner = styled(Spinner)`
    float: left;
    margin-right: 10px;
`;